import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const deviceModelConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default deviceModelConfig;
